import { makeStyles } from '../../../../../../styles';
export const VIEWS_MENU_MIN_WIDTH = 360;
export const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        minWidth: VIEWS_MENU_MIN_WIDTH,
    },
    loadingIndicator: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.67)',
        '& .MuiCircularProgress-root': {
            height: theme.spacing(5),
            width: theme.spacing(5),
        },
    },
    activeView: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        paddingBottom: theme.spacing(1),
    },
    predefinedViews: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    customViews: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(1),
    },
    customViewsInner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: theme.spacing(1),
        maxHeight: theme.spacing(50),
        overflow: 'auto',
    },
    createContainer: {
        display: 'flex',
        gap: theme.spacing(0.5),
        minHeight: theme.spacing(5),
        marginBottom: theme.spacing(1),
        '& .MuiTextField-root': {
            width: '100%',
        },
    },
    createButton: {
        justifyContent: 'flex-start',
        fontWeight: 600,
        minHeight: theme.spacing(5),
        marginBottom: theme.spacing(1),
    },
    createIcon: {
        marginRight: theme.spacing(1),
        height: theme.spacing(1.5),
        width: theme.spacing(1.5),
    },
}));
//# sourceMappingURL=MenuContent.styles.js.map